
<div class="header-toolbar">
  <h1>Données INPI</h1>
</div>

<form #form="ngForm" (ngSubmit)="submit()" autocomplete="off">

  <div class="panel">
    <h2>Recherche d'une société</h2>

    <div class="form-group">
      <label for="siren">Siren</label>
      <input #sirenInput id="siren" type="text" placeholder="Veuillez saisir le siren de la société" [formControl]="siren" maxlength="1000"/>
    </div>
    
    <p style="padding: 16px;">
      <button class="btn btn-primary" type="submit" [disabled]="!valid">
        <t-icon name="search"></t-icon>
        <span class="text">Rechercher</span>
      </button>
    </p>

    <div class="empty-table compact" *ngIf="mode === 'searching'">
      <p>Recherche en cours...</p>
    </div>

    <div class="empty-table compact" *ngIf="mode === 'form' && record === null">
      <p>Aucune société trouvée</p>
    </div>

  </div>

  <div class="grid" *ngIf="record">

    <div class="column">
      
      <div class="panel">
        <h2>Données de Dénomination</h2>

        <div class="form-group">
          <label>Siren</label>
          <span class="value">{{ record.denomination.siren }}</span>
        </div>

        <div class="form-group">
          <label>Dénomination</label>
          <span class="value">{{ record.denomination.denominationSociale }}</span>
        </div>
      </div>

      <div class="panel">

        <div class="form-group">
          <h2>Données XML</h2>
          <textarea rows="17" style="font-family: 'Courier New', Courier, monospace;" spellcheck="false">{{ record.xmlData.join('\n') }}</textarea>
        </div>

      </div>

    </div>
    
    <div class="column">

      <div class="panel">
        <h2>Données mappées Société</h2>

        <div class="form-group">
          <label>Nom de la société</label>
          <span class="value">{{ record.mappedData["societe.nom"] }}</span>
          <span class="info info-right">societe.nom</span>
        </div>

        <div class="form-group">
          <label>Forme sociale</label>
          <span class="value">{{ record.mappedData["societe.forme_sociale"] }}</span>
          <span class="info info-right">societe.forme_sociale</span>
        </div>

        <div class="form-group">
          <label>Capital social (en chiffres)</label>
          <span class="value">{{ record.mappedData["societe.capital_social"] }}</span>
          <span class="info info-right">societe.capital_social</span>
        </div>

        <div class="form-group">
          <label>Numéro de RCS</label>
          <span class="value">{{ record.mappedData["societe.rcs"] }}</span>
          <span class="info info-right">societe.rcs</span>
        </div>

        <div class="form-group">
          <label>Greffe (Ville)</label>
          <span class="value">{{ record.mappedData["societe.greffe"] }}</span>
          <span class="info info-right">societe.greffe</span>
        </div>

        <div class="form-group">
          <label>Date d'immatriculation</label>
          <span class="value">{{ record.mappedData["societe.date_immatriculation"] }}</span>
          <span class="info info-right">societe.date_immatriculation</span>
        </div>

        <div class="form-group">
          <label>Durée</label>
          <span class="value">{{ record.mappedData["societe.duree"] }}</span>
          <span class="info info-right">societe.duree</span>
        </div>

        <div class="form-group">
          <label>Date de cloture de l'exercice</label>
          <span class="value">{{ record.mappedData["societe.date_cloture_exercice"] }}</span>
          <span class="info info-right">societe.date_cloture_exercice</span>
        </div>
        
      </div>

    </div>

  </div>

  <div class="panel" *ngIf="record">

    <h2>Liste des actes</h2>

    <table>
      <tr>
        <th>Identifiant</th>
        <th>Date de dépot</th>
        <th>Nature de l'archive</th>
        <th></th>
      </tr>
      <tbody>
        <tr *ngFor="let document of record.listActe">
          <td  style="cursor: default;">
            {{ document.idFichier }}
          </td>
          <td  style="cursor: default;">
            {{ document.dateDepot }}
          </td>
          <td style="cursor: default;">
            {{ document.natureArchive }}
          </td>
          <td class="actions">
            <a class="action-btn" href="{{ '/inpi/documents/' + document.idFichier }}" title="Télécharger" target="_blank">
              <t-icon name="file_download"></t-icon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>

  </div>

  <div class="panel" *ngIf="record">

    <h2>Liste des bilans annuels</h2>

    <table>
      <tr>
        <th>Identifiant</th>
        <th>Date de dépot</th>
        <th>Date de clôture</th>
        <th>Nature de l'archive</th>
        <th></th>
      </tr>
      <tbody>
        <tr *ngFor="let document of record.listBillanAnnuel">
          <td  style="cursor: default;">
            {{ document.idFichier }}
          </td>
          <td  style="cursor: default;">
            {{ document.dateDepot }}
          </td>
          <td  style="cursor: default;">
            {{ document.dateCloture }}
          </td>
          <td style="cursor: default;">
            {{ document.natureArchive }}
          </td>
          <td class="actions">
            <a class="action-btn" href="{{ '/inpi/documents/' + document.idFichier }}" title="Télécharger" target="_blank">
              <t-icon name="file_download"></t-icon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>

  </div>

  <div class="panel" *ngIf="record">

    <h2>Liste des comptes annuels saisis</h2>

    <table>
      <tr>
        <th>Identifiant</th>
        <th>Date de dépot</th>
        <th>Date de clôture</th>
        <th>Code type bilan</th>
        <th></th>
      </tr>
      <tbody>
        <tr *ngFor="let document of record.listCompteAnnuelSaisi">
          <td  style="cursor: default;">
            {{ document.idFichier }}
          </td>
          <td  style="cursor: default;">
            {{ document.dateDepot }}
          </td>
          <td  style="cursor: default;">
            {{ document.dateCloture }}
          </td>
          <td style="cursor: default;">
            {{ document.codeTypeBilan }}
          </td>
          <td class="actions">
            <a class="action-btn" href="{{ '/inpi/documents/' + document.idFichier }}" title="Télécharger" target="_blank">
              <t-icon name="file_download"></t-icon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
  
</form>